export default __webpack_public_path__ + "static/media/facebookw.b6725b87.svg";